exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-0e1c1590]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.modal-close[data-v-0e1c1590]{cursor:pointer}@media(max-width: 400px){.modal-content[data-v-0e1c1590]{padding-left:20px;padding-right:20px}}.col[data-v-0e1c1590]{padding-left:8px;padding-right:8px}", ""]);

// exports
